export const ProgressRouting = [
  {
    path: "/work-manage/progress/list",
    name: "purchase-progress-list",
    meta: { title: "进度填报" },
    notice: { type: "progress_write_examine", hasNotice: false },
    component: () => import("@/views/work-manage/progress/list/index.vue"),
  },
  {
    hidden: true,
    path: "/work-manage/progress/create",
    name: "purchase-progress-create",
    meta: { title: "新增进度填报", comName: "WorkManageProgressFormCreate" },
    component: () => import("@/views/work-manage/progress/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/work-manage/progress/edit/:id",
    name: "purchase-progress-edit",
    meta: { title: "编辑进度填报", comName: "WorkManageProgressFormCreate" },
    component: () => import("@/views/work-manage/progress/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/work-manage/progress/flowPrint/:id",
    name: "purchase-progress-print",
    meta: { title: "打印详情" },
    component: () => import("@/views/work-manage/progress/form-print/index.vue"),
  },
  {
    hidden: true,
    path: "/work-manage/progress/detail/:id",
    name: "purchase-progress-detail",
    meta: { title: "进度填报详情" },
    component: () => import("@/views/work-manage/progress/form-detail/index.vue"),
  },
];
